import { useEffect, useRef } from 'react';
import { PanResponder } from 'react-native';
import { OrientationType } from 'react-native-orientation-locker';
export const useSwipeDownOnVideoPanHandler = ({ isFullscreen, desiredPlayerOrientation, onToggleFullscreen, }) => {
    const panResponder = useRef(PanResponder.create({
        onMoveShouldSetPanResponder: (_event, gestureState) => false,
        onPanResponderRelease: () => { },
    })).current;
    useEffect(() => {
        const newPanResponder = PanResponder.create({
            onMoveShouldSetPanResponder: (_event, gestureState) => {
                if (isFullscreen) {
                    if (desiredPlayerOrientation === OrientationType['PORTRAIT']
                        && Math.abs(gestureState.dy) > Math.abs(gestureState.dx)
                        && gestureState.dy > 30) {
                        return true;
                    }
                    else if (desiredPlayerOrientation === OrientationType['LANDSCAPE-LEFT']
                        && Math.abs(gestureState.dx) > Math.abs(gestureState.dy)
                        && gestureState.dx < -30) {
                        return true;
                    }
                    else if (desiredPlayerOrientation === OrientationType['LANDSCAPE-RIGHT']
                        && Math.abs(gestureState.dx) > Math.abs(gestureState.dy)
                        && gestureState.dx > 30) {
                        return true;
                    }
                }
                return false;
            },
            onPanResponderRelease: (_event, gestureState) => {
                if ((desiredPlayerOrientation === OrientationType['PORTRAIT']
                    && gestureState.dy > 30)
                    || (desiredPlayerOrientation === OrientationType['LANDSCAPE-LEFT']
                        && gestureState.dx < -30)
                    || (desiredPlayerOrientation === OrientationType['LANDSCAPE-RIGHT']
                        && gestureState.dx > 30)) {
                    onToggleFullscreen();
                }
            }
        });
        panResponder.panHandlers = newPanResponder.panHandlers;
    }, [
        isFullscreen,
        desiredPlayerOrientation,
    ]);
    return panResponder;
};
//# sourceMappingURL=useSwipeDownOnVideoPanHandler.js.map